const getURIStringFromObj = (obj: {
    [key: string]: any;
}) => {
    let res = [];
    for (let property in obj) {
        let encodedKey = encodeURIComponent(property);
        let encodedValue = encodeURIComponent(obj[property]);
        res.push(encodedKey + "=" + encodedValue);
    }
    const URIString = res.join("&");

    return URIString;
}

export default getURIStringFromObj;